import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/billing_rules',
  component: Management,
  redirect: '/billing_rules/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/billing_rules/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listBillingRules
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/billing_rules/ListTable'),
          meta: {
            auth: Auth.listBillingRules,
            tabName: 'all'
          }
        },
        {
          path: 'station_in_used',
          component: () => import('@/views/billing_rules/ListTable'),
          meta: {
            auth: Auth.listBillingRules,
            tabName: 'station_in_used'
          }
        },
        {
          path: 'charge_point_in_used',
          component: () => import('@/views/billing_rules/ListTable'),
          meta: {
            auth: Auth.listBillingRules,
            tabName: 'charge_point_in_used'
          }
        },
        {
          path: 'group_in_used',
          component: () => import('@/views/billing_rules/ListTable'),
          meta: {
            auth: Auth.listBillingRules,
            tabName: 'group_in_used'
          }
        },
        {
          path: 'vip_station_in_used',
          component: () => import('@/views/billing_rules/ListTable'),
          meta: {
            auth: Auth.listBillingRules,
            tabName: 'vip_station_in_used'
          }
        },
        {
          path: 'not_used',
          component: () => import('@/views/billing_rules/ListTable'),
          meta: {
            auth: Auth.listBillingRules,
            tabName: 'not_used'
          }
        },
        {
          path: 'special_billing_rule',
          component: () => import('@/views/special_billing_rules/ListTable'),
          meta: {
            auth: Auth.listStationSpecialBillingRules,
            tabName: 'special_billing_rule'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/billing_rules/New'),
      meta: {
        auth: Auth.createBillingRule
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/billing_rules/Edit'),
      meta: {
        auth: Auth.updateBillingRule
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/billing_rules/DetailLayout'),
      meta: {
        auth: Auth.showBillingRule
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/billing_rules/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showBillingRule
          }
        }
      ]
    }
  ]
}
